import { BannerAtom, bannersAtom } from "@/atoms/bannersState"
import { Container } from "@mui/material"
import { useAtomValue } from "jotai"
import { usePathname } from "next/navigation"

import CardCarousel from "@/components/base/CardCarousel"
import AdvertisementItem from "./components/AdvertisementItem"
import AdsSkeleton from "./components/AdsSkeleton"

const View = () => {
  const banners = useAtomValue(bannersAtom)
  const routePathname = usePathname()
  const isHome = routePathname === "/home"

  if (!banners || !banners?.length) return <AdsSkeleton isHome={isHome} />

  return (
    <Container data-test-id='adSection' maxWidth='xl' className={isHome ? "mt-10 px-0" : "mt-4"}>
      <CardCarousel
        id='advertisement'
        xs={1}
        sm={isHome ? 2 : 1}
        md={isHome ? 3 : 2}
        autoplay={{ delay: 3000 }}
        items={banners.map((item: BannerAtom) => (
          <AdvertisementItem key={`banner-${item.id}`} {...item} isHome={isHome} />
        ))}
      />
    </Container>
  )
}

export default View
